module.exports = __webpack_public_path__ + "static/media/fruitNinja.e119da68.png";